'use client';

import { c as _c } from "react/compiler-runtime";
import React, { FC, PropsWithChildren, createContext, useContext } from 'react';
import { getMerchantBySlug } from '@ordering/api/getMerchantBySlug';
import { getMerchantBusinessProfile } from '@ordering/api/getMerchantBusinessProfile';
import { BusinessProfile } from '@ordering/api/getMerchantBusinessProfile';
type BusinessProfileProviderProps = {
  merchantSlug: string;
  storefrontSlug: string;
};
const BusinessProfileContext = createContext<BusinessProfile | null>(null);
export const useBusinessProfile = () => {
  return useContext(BusinessProfileContext);
};
export const BusinessProfileProvider: FC<PropsWithChildren<BusinessProfileProviderProps>> = t0 => {
  const $ = _c(4);
  const {
    children,
    merchantSlug,
    storefrontSlug
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== merchantSlug || $[2] !== storefrontSlug) {
    t1 = <BusinessProfileWrapper merchantSlug={merchantSlug} storefrontSlug={storefrontSlug}>{children}</BusinessProfileWrapper>;
    $[0] = children;
    $[1] = merchantSlug;
    $[2] = storefrontSlug;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};
const BusinessProfileWrapper = ({
  merchantSlug,
  storefrontSlug,
  children
}: {
  merchantSlug: string;
  storefrontSlug: string;
  children: React.ReactNode;
}) => {
  const [businessProfile, setBusinessProfile] = React.useState<BusinessProfile | null>(null);
  React.useEffect(() => {
    const fetchBusinessProfile = async () => {
      try {
        const {
          merchant,
          timezone
        } = await getMerchantBySlug(merchantSlug, storefrontSlug);
        const merchantCode = merchant?.code;
        if (merchantCode) {
          const profile = await getMerchantBusinessProfile(merchantCode);
          setBusinessProfile({
            ...profile,
            code: merchantCode,
            timezone: timezone || 'UTC'
          });
        }
      } catch (error) {
        console.error('Error fetching business profile:', error);
      }
    };
    fetchBusinessProfile();
  }, [merchantSlug, storefrontSlug]);
  return <BusinessProfileContext.Provider value={businessProfile}>{children}</BusinessProfileContext.Provider>;
};